'use strict';
angular.module('schoolLinqApp').factory('unitListItemService', [
	'$http',
	function ($http) {
		var endpoint = '/api/unit-list-items';

		function getFieldList(fieldName) {
			return $http.get(endpoint, {
				params: { fieldName: fieldName },
			});
		}

		function getOrbitMiscPayTypes() {
			return getFieldList('OrbitMiscPayType');
		}

		return {
			getFieldList: getFieldList,
			getOrbitMiscPayTypes: getOrbitMiscPayTypes,
		};
	},
]);
